import { createSlice } from "@reduxjs/toolkit";
import { faqDetailsAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const faqDetailsSlice = createSlice({
  name: "faqDetails",
  initialState: data,
  reducers: {
    faqDetailsSlice(state) {
      state.isLoading = false;
    },
    faqDetailsSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    faqDetailsSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    faqDetailsSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const faqDetailsHandler = () => async (dispatch: any) => {
  try {
    dispatch(faqDetailsAction.faqDetailsSlice());
    const response: any = await faqDetailsAPI();
    dispatch(faqDetailsAction.faqDetailsSliceSuccess(response));
  } catch (e: any) {
    dispatch(faqDetailsAction.faqDetailsSliceFailure(e?.response?.data?.message));
    dispatch(faqDetailsAction.faqDetailsSliceReset());
  }
};
export default faqDetailsSlice.reducer;
export const faqDetailsAction = faqDetailsSlice.actions;
